/** Default page size for worker chat history (matches API default). */
export const WORKER_MESSAGE_PAGE_SIZE = 75;

/** Max workers returned in a single list request. */
export const WORKERS_LIST_LIMIT = 100;
